module.exports = __webpack_public_path__ + "static/media/claims.cb1b11c5.jpg";